module.exports = __webpack_public_path__ + "static/media/value_prop_img_3.bb929c08.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/value_prop_img_3.jpg
// module id = 1416
// module chunks = 0